import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import './SubSection.scss';

const emphasiseStyle = {
  fontWeight: '500',
  borderTop: '1px solid black'
};

const sperateSectionStyle = {
  paddingTop: '2rem',
};

const SubSection = props => (
  <div className="sub-section-container">
    {props.title &&
    <h4 className="sub-section-title">{props.title}</h4>
    }
    {map(props.content, (section, index) => {
      if (section) {
        let style = {};
        if (section.emphasise) {
          style = { ...style, ...emphasiseStyle };
        }
        if (section.isSeprate) {
          style = { ...style, ...sperateSectionStyle };
        }
        return (
          <div key={index} className="sub-section" style={style}>
            <div className="sub-section-left-content">
              {section.leftContent}
            </div>
            {section.rightContent &&
            <div className="sub-section-right-content">
              {section.rightContent}
            </div>
            }
          </div>
        );
      }
      return null;
    })}
  </div>
);

SubSection.propTypes = {
  title: PropTypes.string,
  content: PropTypes.arrayOf(PropTypes.object)
};

export default SubSection;



/** WEBPACK FOOTER **
 ** ./src/components/SubSection/SubSection.js
 **/